/* eslint no-param-reassign: "off", no-console: "off" */
const favoritesStore = {
  state: {
    remotes: []
  },
  mutations: {
    removeRemoteFavorite(state, payload) {
      state.remotes = state.remotes.filter(r => r.id != payload);
    },
    addRemoteFavorite(state, payload) {
      state.remotes.push(payload);
    },
    setRemotes(state, payload) {
      state.remotes = payload;
    }
  },
  actions: {
    async toggleRemoteFavorite({ state, commit }, remote) {
      const existingFav = state.remotes.find(r => r.id == remote.id);
      if (existingFav) {
        commit('removeRemoteFavorite', remote.id);
      } else {
        commit('addRemoteFavorite', remote);
      }
      // eslint-disable-next-line no-undef
      await $userStore.setItem('favoriteRemotes', state.remotes);
    },
    async getFavoritedRemotesList({ commit }) {
      // eslint-disable-next-line no-undef
      const result = await $userStore.getItem('favoriteRemotes');
      if (result) {
        commit('setRemotes', result || []);
      }
    },
    async fetchFavorites({ dispatch }) {
      await dispatch('getFavoritedRemotesList');
    }
  },
  getters: {
    remoteFavorites: (state) => state.remotes.sort((a, b) => a.name - b.name)
  }
}

export default favoritesStore;
